import { FC, useEffect, useRef } from 'react';
import React from 'react';

// @ts-ignore
import ReactPlayerLoader from '@brightcove/react-player-loader';
import ReactDOM from 'react-dom';

import { sendEventToGTM } from '@utils_common/sendEventToGTM';

import styles from './video.module.scss';

//このファイル全体でEsLintを無効にする
/* eslint-disable */

type Props = {
  eventName: string;
};

const Video: FC<Props> = ({ eventName }) => {
  const playerRef = useRef(null);

  useEffect(() => {
    if (playerRef.current) {
      const reactPlayerLoader = ReactDOM.render(
        React.createElement(ReactPlayerLoader, {
          accountId: '5731660808001',
          videoId: '6345171810112',
          playerId: 'Hkj02RRpz',
          embedOptions: {
            responsive: true,
          },
          onSuccess: (success: any) => {
            const player = success.ref;
            // ビデオをミュートに設定
            player.muted(true);
            // ビデオの再生を試みる
            player.play().catch((error: any) => {
              console.error('自動再生に失敗しました:', error);
            });
            player.playsinline(true);
            success.ref.on('play', () => {
              sendEventToGTM({ event: eventName });
            });
          },
        }),
        playerRef.current,
      );
    }
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.tv_frame}>
        <img src="/images/iqfu/next_japan/hero_tv.svg" />
        <div className={styles.video_container}>
          <div id="fixture" ref={playerRef} />
        </div>
      </div>
    </div>
  );
};

export default Video;
